import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { InstagramLogo } from 'phosphor-react';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white py-12 px-8">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h3 className="text-xl font-bold mb-4">Atelier Ambree</h3>
          <p className="text-gray-400 text-sm">{t('footer.description')}</p>
        </div>
        <div className="flex items-start">
          <div className="flex flex-wrap items-center text-sm text-gray-400 mt-6">
            <Link to="/" className="hover:text-white transition">{t('nav.home')}</Link>
            <span className="mx-2">|</span>
            <Link to="/shop" className="hover:text-white transition">{t('nav.shop')}</Link>
            <span className="mx-2">|</span>
            <Link to="/about" className="hover:text-white transition">{t('nav.about')}</Link>
            <span className="mx-2">|</span>
            <Link to="/contact" className="hover:text-white transition">{t('nav.contact')}</Link>
            <span className="mx-2">|</span>
            <Link to="/shipping" className="hover:text-white transition">{t('nav.shipping')}</Link>
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-8 pt-8 border-t border-gray-800 flex flex-col items-center space-y-4">
        <a 
          href="https://instagram.com/atelierambree" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-white transition"
        >
          <InstagramLogo size={24} />
        </a>
        <p className="text-sm text-gray-400">Gemaakt met ❤️ door <a href="https://www.linkedin.com/in/stef-venmans/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300 transition">Stef Venmans</a> | {t('footer.copyright')}</p>
      </div>
    </footer>
  );
}

export default Footer; 